import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TextAreaFieldGroup from "../common/TextAreaFieldGroup";
import { addPost } from "../../actions/postActions";
import { addCitiesPost } from "../../actions/citiesPostActions";
import { addImage,getImages } from "../../actions/imageActions";
import { addExtraNowImage,getExtraNowImages } from "../../actions/extraNowImageActions";


import * as XLSX from 'xlsx/xlsx.mjs';

import TextFieldGroup from "../common/TextFieldGroup";
import SelectListGroup from "../common/SelectListGroup";
import { optionsCountries, optionsDomiciliation } from "../constants";
import { Card, Button, Row, Col, Accordion } from "react-bootstrap";
import InputGroup from "../common/InputGroup";
import FacebookPost from "../facebook/FacebookPost";

//import FacebookCurrent from "../facebook/FacebookCurrent";

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      job_title: "",
      location_city: "",
      location_country: "",
      remote: "",
      level: "",
      text: "",
      link: "",
      rent: "",
      errors: {},
      title:"",
      category: "",
      description: "",
      file: "",
      urlData:"",
      extraUrl:""
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    
    this.onChangeImage = this.onChangeImage.bind(this);
    this.onSubmitImage = this.onSubmitImage.bind(this);

    this.onChangeCitiesPost = this.onChangeCitiesPost.bind(this);
    this.onSubmitCitiesPosts = this.onSubmitCitiesPosts.bind(this);

    this.onChangeExtraNow = this.onChangeExtraNow.bind(this);
    this.onSubmitExtraNow = this.onSubmitExtraNow.bind(this);

  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.errors) {
      this.setState({ errors: newProps.errors });
    }
  }


  componentDidMount(){
    this.loadExcel()
    this.onSubmitImage()
    
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onChangeCitiesPost(e){
    this.setState({ [e.target.name]: e.target.value });
  }

  onChangeImage(e){
    this.setState({ [e.target.name]: e.target.value });
  }


  onChangeExtraNow(e){
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmit(e) {
    e.preventDefault();

    const { user } = this.props.auth;

    const newPost = {
      job_title: this.state.job_title,
      location_city: this.state.location_city,
      location_country: this.state.location_country,
      remote: this.state.remote,
      level: this.state.level,
      text: this.state.text,
      link: this.state.link,
      rent: this.state.rent,
      name: user.name,
      avatar: user.avatar,
    };

    this.props.addPost(newPost);
    this.setState({
      job_title: "",
      location_city: "",
      location_country: "",
      remote: "",
      level: "",
      text: "",
      link: "",
      rent: "",
    });
  }

  onSubmitCitiesPosts(e) {
    e.preventDefault();

    const { user } = this.props.auth;
    const formatedFile = JSON.stringify(JSON.parse(this.state.file))
    const newCitiesPost = {
      title: this.state.title,
      category: this.state.category,
      description: this.state.description,
      
      file: formatedFile,
      name: user.name,
    };

    this.props.addCitiesPost(newCitiesPost);
    this.setState({
      title: "",
      category: "",
      description: "",
      file: "",
      
    });
  }

  onSubmitImage() {

    
    const newImage = {  
      url:this.state.urlData
    };

    this.props.addImage(newImage);
  //  
  }

  onSubmitExtraNow(e) {
    e.preventDefault()

    const newExtraNowImage = {  
      url:this.state.extraUrl
    };

    this.props.addExtraNowImage(newExtraNowImage);

    this.setState({
      extraUrl: ""
    });
   
  }


  
  loadExcel (){
    var selectedFile;
      document.getElementById("fileUpload").addEventListener("change", function(event) {
           selectedFile = event.target.files[0];
        });
      document
        .getElementById("uploadExcel")
        .addEventListener("click", function () {
          if (selectedFile) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
              var data = event.target.result;
  
              var workbook = XLSX.read(data, {
                type: "binary"
              });
              workbook.SheetNames.forEach((sheet) => {
                let rowObject = XLSX.utils.sheet_to_row_object_array(
                  workbook.Sheets[sheet]
                );
                  const jsonObject = JSON.stringify(rowObject);
                document.getElementById("jsonData").innerHTML = jsonObject;
                console.log(rowObject);
              });
            };
            fileReader.readAsBinaryString(selectedFile);
          }
        });
  }

  render() {
    const { errors } = this.state;
    const { user } = this.props.auth;
    const {citiesposts, loading} = this.props.citiespost;
    const {images, loadingImg} = this.props.image;
    const filelist =citiesposts && citiesposts.map(a=>a.file).filter((item)=>item!==undefined)
    //const imageList = images.map(a=>a.imgUlrs).filter((item)=>item!=='')


         let fileData =[]

        if(filelist){
          filelist.forEach((citiespost)=>{
            JSON.parse(citiespost).forEach((item)=>{
              fileData.push(item)
           
            })

           
           
       })
        }

        // console.log('filedata', fileData)
         const newFileData = fileData.filter((elt)=>Number(elt.Price)<700)
        // console.log('newFiledata', newFileData)
    
    

    return (
      <div className="post-form mb-3">
        {user.role === "admin" ? (
          <div className="card card-info">
            <Accordion>
              <Accordion.Toggle as={Button} variant="link" eventKey="0">
                <div className="card-header bg-info text-white">
                  <i className="bi bi-pencil-square"></i> Say Something...
                </div>
              </Accordion.Toggle>
              <Accordion.Toggle as={Button} variant="link" eventKey="1">
                <div className="card-header bg-info text-white">
                  <i className="bi bi-facebook"></i> Cities Posts...
                  <i className="bi bi-pencil-square"></i>
                </div>
              </Accordion.Toggle>
              <Accordion.Toggle as={Button} variant="link" eventKey="2">
                <div className="card-header bg-info text-white">
                  <i className="bi bi-facebook"></i> Logement Rapide...
                  <i className="bi bi-pencil-square"></i>
                </div>
              </Accordion.Toggle>
              <Accordion.Toggle as={Button} variant="link" eventKey="3">
                <div className="card-header bg-info text-white">
                  <i className="bi bi-facebook"></i> Extra Now
                  <i className="bi bi-pencil-square"></i>
                </div>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <div className="card-body">
                    <form onSubmit={this.onSubmit}>
                      <div className="form-group">
                        <Row>
                          <Col>
                            {" "}
                            <InputGroup
                              placeholder="Post Title"
                              name="job_title"
                              value={this.state.job_title}
                              onChange={this.onChange}
                              error={errors.job_title}
                            />
                          </Col>
                          {/* <Col>
                            {" "}
                            <SelectListGroup
                              placeholder="Location"
                              name="level"
                              value={this.state.level}
                              onChange={this.onChange}
                              error={errors.level}
                              options={optionsLevel}
                            />
                          </Col> */}
                          <Col>
                            {" "}
                            <SelectListGroup
                              placeholder="Domiciliation"
                              name="remote"
                              value={this.state.remote}
                              onChange={this.onChange}
                              error={errors.remote}
                              options={optionsDomiciliation}
                            />
                          </Col>
                          <Col>
                            <TextFieldGroup
                              placeholder="*Neigbourhoods"
                              name="level"
                              value={this.state.level}
                              onChange={this.onChange}
                              error={errors.level}
                              info="eg.
                    Ixelles,Saint-Gille"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <TextFieldGroup
                              placeholder="rent"
                              name="rent"
                              value={this.state.rent}
                              onChange={this.onChange}
                              error={errors.rent}
                              info=" rent/month"
                            />
                          </Col>
                          <Col>
                            {" "}
                            <InputGroup
                              placeholder="City"
                              name="location_city"
                              value={this.state.location_city}
                              onChange={this.onChange}
                              error={errors.location_city}
                            />
                          </Col>
                          <Col>
                            {" "}
                            <SelectListGroup
                              placeholder="Country"
                              name="location_country"
                              value={this.state.location_country}
                              onChange={this.onChange}
                              error={errors.location_country}
                              options={optionsCountries}
                            />
                          </Col>
                        </Row>

                        <TextAreaFieldGroup
                          placeholder="Description"
                          name="text"
                          value={this.state.text}
                          onChange={this.onChange}
                          error={errors.text}
                        />
                        <TextFieldGroup
                          placeholder="link"
                          name="link"
                          value={this.state.link}
                          onChange={this.onChange}
                          error={errors.link}
                          info="Attach a link link"
                        />
                      </div>
                      <button type="submit" className="btn btn-dark">
                        Submit
                      </button>
                    </form>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
              <Accordion.Collapse eventKey="1">
              <Card.Body>
                <div className="card-body">
                  <form onSubmit={this.onSubmitCitiesPosts}>
                    <div className="form-group">
                    <Row>
                      <div>
                      <input type="file" id="fileUpload" accept=".xls,.xlsx" /><br />
    
       <textarea id="jsonData" rows={5} cols={90}  style={{width:"100%"}}
                        name="exceltojson"
                        disabled={true}>

    </textarea>
    <button type="button" id="uploadExcel">Convert</button>
                      </div>
                    
                    </Row>
                      <Row>
                        <Col>
                          {" "}
                          <InputGroup
                            placeholder=" Title"
                            name="title"
                            value={this.state.title}
                            onChange={this.onChangeCitiesPost}
                            error={errors.title}
                          />
                        </Col>
                        
                        
                      </Row>
                      <Row>
                        <Col>
                          {" "}
                          <InputGroup
                            placeholder="Category"
                            name="category"
                            value={this.state.category}
                            onChange={this.onChangeCitiesPost}
                            error={errors.category}
                          />
                        </Col>
                        
                      </Row>

                      <TextAreaFieldGroup
                        placeholder={this.state.file}
                        name="file"
                        value={this.state.file}
                        onChange={this.onChangeCitiesPost}
                        error={errors.file}
                      />
                      <TextFieldGroup
                        placeholder="description"
                        name="description"
                        value={this.state.description}
                        onChange={this.onChangeCitiesPost}
                        error={errors.description}
                        info="Attach a description"
                      />
                    </div>
                    <button type="submit" className="btn btn-dark">
                      Submit
                    </button>
                  </form>
                </div>
              </Card.Body>
            </Accordion.Collapse>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  <div className="card-body">
                    <FacebookPost fileData={newFileData}/>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  <div className="card-body">
                    <form onSubmit={this.onSubmitExtraNow}>
                      <div className="form-group">
                    
                        <TextFieldGroup
                          placeholder='add new url'
                          name="extraUrl"
                          value={this.state.extraUrl}
                          onChange={this.onChangeExtraNow}
                         
                          info="Attach a link extraUrl"
                        />
                      </div>
                      <button type="submit" className="btn btn-dark">
                        Submit
                      </button>
                    </form>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
              {/* <Accordion.Collapse eventKey="2">
                <Card.Body>
                  <div className="card-body">
                    <FacebookCurrent />
                  </div>
                </Card.Body>
              </Accordion.Collapse> */}
            </Accordion>

            <div
              className="fb-like"
              data-share="true"
              data-width="450"
              data-show-faces="true"
            ></div>
          </div>
        ) : null}
      </div>
    );
  }
}

PostForm.propTypes = {
  addPost: PropTypes.func.isRequired,
  addCitiesPost: PropTypes.func.isRequired,
  addExtraNowImage:PropTypes.func.isRequired,
  addImage: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  citiespost: state.citiespost,
  image:state.image,
  errors: state.errors,
  isEditing: state.isEditing,
});

export default connect(mapStateToProps, { addPost, addCitiesPost, addImage,addExtraNowImage})(PostForm);
